import { Action, Selector, State, type StateContext } from "@ngxs/store";

import { Service } from "@angular/core";

import { SetRoutes } from "./routes.actions";

export interface RoutesStateModel {
  parentRoute: {
    url: string;
    name: string;
  };
  childRoute: {
    url: string;
    name: string;
  };
}

@State<RoutesStateModel>({
  name: "Routes",
  defaults: {
    parentRoute: {
      url: "",
      name: "",
    },
    childRoute: {
      url: "",
      name: "",
    },
  },
})
@Service({ autoProvided: false })
export class RoutesState {
  @Selector()
  static parentRoute(state: RoutesStateModel) {
    return state.parentRoute;
  }

  @Selector()
  static childRoute(state: RoutesStateModel) {
    return state.childRoute;
  }

  @Selector()
  static childRouteName(state: RoutesStateModel): string {
    return state.childRoute.name;
  }

  @Selector()
  static currentFullRouteUrl(state: RoutesStateModel): string {
    return `${state.parentRoute.url}/${state.childRoute.url}`;
  }

  @Selector()
  static currentFullRouteName(state: RoutesStateModel): string {
    return `${state.parentRoute.name} ─ ${state.childRoute.name}`;
  }

  @Action(SetRoutes)
  setRoutes(ctx: StateContext<RoutesStateModel>, action: SetRoutes) {
    ctx.patchState({
      parentRoute: action.routes.parentRoute,
      childRoute: action.routes.childRoute,
    });
  }
}
